var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upgrade_2512640",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.8,
    height: 46.8,
    viewBox: "0 0 46.8 46.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 0.063,
    x2: 0.979,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d37c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903163"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9942",
    "data-name": "Path 9942",
    d: "M181.882,102.235h1.377a1.61,1.61,0,0,1,1.61,1.61s0,6.116,0,9.107H189.3c0-2.97,0-9.027,0-9.107a1.61,1.61,0,0,1,1.61-1.61h1.51L187.31,95.3Z",
    transform: "translate(-163.694 -85.772)",
    fill: "#dc864d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9943",
    "data-name": "Path 9943",
    d: "M23.4,0A23.4,23.4,0,1,0,46.8,23.4,23.4,23.4,0,0,0,23.4,0Zm3.827,41.541H19.573V38.32h7.654Zm1.353-5.57H18.22V32.75H28.58Zm3.337-16.287H28.83V28.67a1.619,1.619,0,0,1-1.61,1.73H19.565a1.626,1.626,0,0,1-1.61-1.73V19.683H14.883c-1.48.031-1.788-1.794-1.268-2.6L22.288,6c.218-.779,2.114-.85,2.662-.089l8.263,11.2a1.737,1.737,0,0,1-1.3,2.566Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgrade_icon.535a0c1a589930b3e90f216d9bc8a04e.svg";
export { ForwardRef as ReactComponent };